module.exports = __webpack_public_path__ + "static/media/ban-img2.14c630dd.png";